import { useMemo } from 'react';
import { useGetLogisticOperatorsQuery } from '@/pages/Business/pages/LogisticOperator/services';
import type { SelectInputOption } from '@/components/inputs/SelectInput';

/**
 * Devuelve las opciones de operadores logísticos para el selector y un mapa
 * id -> nombre para resolver el nombre en la tabla.
 */
const useLogisticOperatorOptions = () => {
  const { data, isLoading } = useGetLogisticOperatorsQuery({
    paginated: { page: 1, pageSize: 200 },
  });

  const operators = data?.items ?? [];

  const options: SelectInputOption[] = useMemo(
    () =>
      operators.map((operator) => ({
        label: operator.fullName || operator.businessName || operator.id,
        value: operator.id,
      })),
    [operators]
  );

  const nameById = useMemo(() => {
    const map: Record<string, string> = {};
    operators.forEach((operator) => {
      map[operator.id] = operator.fullName || operator.businessName || operator.id;
    });
    return map;
  }, [operators]);

  return { options, nameById, isLoading };
};

export default useLogisticOperatorOptions;
